"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  de: {
    collapseTextOverlayOptions: 'Optionen für die Textdarstellung einklappen',
    disableTextOverlay: 'Textdarstellung deaktivieren',
    enableTextOverlay: 'Textdarstellung aktivieren',
    expandTextOverlayOptions: 'Optionen für die Textdarstellung ausklappen',
    textOpacity: 'Text-Transparenz',
    textSelect: 'Text auswählbar',
    textVisible: 'Text sichtbar',
    colorPicker: 'Farbauswahl',
    textColor: 'Farbe für Text',
    backgroundColor: 'Farbe für Zeilenhintergrund',
    resetTextColors: 'Farben zurücksetzen'
  },
  en: {
    collapseTextOverlayOptions: 'Collapse text overlay options',
    disableTextOverlay: 'Disable text overlay',
    enableTextOverlay: 'Enable text overlay',
    expandTextOverlayOptions: 'Expand text overlay options',
    textOpacity: 'Text opacity',
    textSelect: 'Text selectable',
    textVisible: 'Text visible',
    colorPicker: 'Color picker',
    textColor: 'Text color',
    backgroundColor: 'Line background color',
    resetTextColors: 'Reset colors'
  },
  sr: {
    collapseTextOverlayOptions: 'Затворите опције приказа текста',
    disableTextOverlay: 'Приказ текста онемогућен',
    enableTextOverlay: 'Приказ текста омогућен',
    expandTextOverlayOptions: 'Опције приказа текста отоворен',
    textOpacity: 'Видљивост текста',
    textSelect: 'Селекција текста',
    textVisible: 'Видљив текст',
    colorPicker: 'Избор боја',
    textColor: 'Боја текста',
    backgroundColor: 'Боја позадине реда',
    resetTextColors: 'Ресет боја'
  }
};
exports["default"] = _default;